import { colors } from "../../ui/color";
import { SettingIcon } from "../../ui/icons/settingIcon";
import { Layout } from "../../ui/layout";
import { MenuItems } from "../../ui/organisms/navbar/dto";

export function Settings() {
    return (
        <Layout
            menuItem={MenuItems.SETTINGS}
            headingLabel={"Impostazioni"}
            headingButtons={[]}
            breadcrumbItems={["Impostazioni"]}
            breadcrumbIcon={<SettingIcon color={colors.pas[500]} size={20} />}
        >
            <></>
        </Layout>
    )
}